import React from 'react'
import "./Ground-banner.css"

const GroundBanner = () => {
    return (
        <div className="ground-banner">
            <h2 className="ground-banner-header">Our Services</h2>
            <p className="ground-banner-p">Have a look at what we offer!! </p>
        </div>
    )
}

export default GroundBanner
